const INTERNAL_ID = /^(?:[a-f\d]{24}|[a-f\d]{8}-[a-f\d]{4}-[1-5][a-f\d]{3}-[89ab][a-f\d]{3}-[a-f\d]{12})$/i;

const readable = (value) => {
  const text = String(value || '').trim();
  return text && !INTERNAL_ID.test(text) ? text : '';
};

export const recommendationGeneratedBy = (report) => {
  const resolved = readable(report?.generated_by_model_display);
  if (resolved) return resolved;
  const stored = readable(report?.generated_by_model);
  if (stored) return stored;
  const generation = Array.isArray(report?.generation_metadata)
    ? report.generation_metadata.find((entry) => entry?.stage === 'generation') || report.generation_metadata[0]
    : null;
  const provider = readable(generation?.provider);
  const model = readable(generation?.model);
  if (provider && model) return model.startsWith(`${provider}/`) ? model : `${provider}/${model}`;
  if (model) return model;
  return 'Not recorded';
};
